import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import ReactHtmlParser from 'react-html-parser';
import {formatNumber} from 'libphonenumber-js';
import Fade from 'react-reveal/Fade';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import IconAgepPeople from '../../../Layout/assets/img/icon-agep-people.svg';
import IconAgepMessages from '../../../Layout/assets/img/icon-agep-messages.svg';
import IconAgepBook from '../../../Layout/assets/img/icon-agep-open-book.svg';
import IconAgepCertificate from '../../assets/img/icon-certificate.svg';
import SchoolMap from "./SchoolMap";
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_school_details';
import Obfuscate from 'react-obfuscate';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CloseIcon from '@material-ui/icons/Close';
import Drawer from "@material-ui/core/Drawer/Drawer";
import IconInfo2 from '@material-ui/icons/Info';
import NumberFormat from 'react-number-format';

class SchoolDetails extends Component {
    state = {
        mobileInfoDrawerOpen: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    toggleInfoDrawer = (open) => () => {
        this.setState({
            mobileInfoDrawerOpen: open,
        });
    };

    render() {
        const {school} = this.props;

        let idArticle = 'school-' + school.id;

        let title = school.title;
        if (school.title_html !== '' && school.title_html !== null) {
            title = ReactHtmlParser(school.title_html);
        }

        let teachingLangs = [];
        let teachingLangsStr = '';
        if (school.teach_in_french === true) {
            teachingLangs.push({
                key: 'fr',
                order: (school.teach_in_order === 'fr') ? 1 : 10,
                label: this.props.translate('school_details.teaching_lang_fr')
            });
        }
        if (school.teach_in_english === true) {
            teachingLangs.push({
                key: 'en',
                order: (school.teach_in_order === 'en') ? 1 : 10,
                label: this.props.translate('school_details.teaching_lang_en')
            });
        }
        if (school.teach_in_german === true) {
            teachingLangs.push({
                key: 'de',
                order: (school.teach_in_order === 'de') ? 1 : 10,
                label: this.props.translate('school_details.teaching_lang_de')
            });
        }
        if (teachingLangs.length > 0) {
            teachingLangs = teachingLangs.sort((a, b) => {
                return (a.order - b.order);
            });

            teachingLangs.forEach(item => {
                teachingLangsStr += item.label + ' / ';
            });
            teachingLangsStr = teachingLangsStr.replace(/ \/ \s*$/, "");
        }

        let typesOfSchool = '';
        if ((Array.isArray(school.types) && school.types.length > 0)) {
            school.types.forEach((item, index) => {
                typesOfSchool += item.name + ' / ';
            });
            typesOfSchool = typesOfSchool.replace(/ \/ \s*$/, "");
        }

        let certificationsStr = '';
        if ((Array.isArray(school.certifications) && school.certifications.length > 0)) {
            school.certifications.forEach((item, index) => {
                certificationsStr += item.name + ' / ';
            });
            certificationsStr = certificationsStr.replace(/ \/ \s*$/, "");
        }

        let thumbnailStyles = {};

        if (school.background_image && school.background_image.details) {
            thumbnailStyles = {
                backgroundImage: 'url("' + school.background_image.details + '")',
            };
        }

        let address = school.address_line1;
        if (school.address_line2 !== '') {
            address += '<br />' + school.address_line2;
        }
        if (school.address_state_province !== '') {
            address += '<br />' + school.address_state_province;
        }
        if (school.address_city !== '') {
            address += '<br />';

            if (school.address_postal_code !== '') {
                address += school.address_postal_code + ' ';
            }

            address += school.address_city;
        }

        let schoolFees = '';
        if ((school.school_fees_min && school.school_fees_min !== '') && (school.school_fees_max && school.school_fees_max !== '')) {
            let minFormatted = <NumberFormat value={school.school_fees_min} displayType={'text'} thousandSeparator={'\''} />;
            let maxFormatted = <NumberFormat value={school.school_fees_max} displayType={'text'} thousandSeparator={'\''} />;

            schoolFees = this.props.translate('school_details.school_fees_from_to', {
                min: minFormatted,
                max: maxFormatted
            });
        } else if (school.school_fees_min && school.school_fees_min !== '') {
            let minFormatted = <NumberFormat value={school.school_fees_min} displayType={'text'} thousandSeparator={'\''} />;

            schoolFees = this.props.translate('school_details.school_fees_from', {
                min: minFormatted
            });
        } else if (school.school_fees_max && school.school_fees_max !== '') {
            let maxFormatted = <NumberFormat value={school.school_fees_max} displayType={'text'} thousandSeparator={'\''} />;

            schoolFees = this.props.translate('school_details.school_fees_to', {
                max: maxFormatted
            });
        }

        return (
            <Fragment>
                <article id={idArticle} className="school">
                    <header>
                        <div className="row">
                            <div className="col col-left col-12 col-lg-4">
                                <div className="wrapper-top">
                                    <Button size="medium" className="btnBack" component={props => <Link to={this.props.translate('routes.schools')} {...props}/>}>
                                        <KeyboardBackspaceIcon className="btnIcon" />
                                        <Translate id="school_details.button_back" />
                                    </Button>

                                    <div className="row row-content no-gutters">
                                        <div className="col col-12">
                                            <h1>{title}</h1>
                                        </div>
                                    </div>

                                    <div id="mobile-featured-image" className="d-block d-lg-none" style={thumbnailStyles}></div>
                                    <div id="mobile-featured-image-layer" className="d-block d-lg-none"></div>
                                </div>

                                <ul className="highlight clearfix">
                                    {school.number_students > 0 &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepPeople} alt="" />
                                            </div>
                                            <div className="content">
                                                <span className="title"><Translate id="school_details.nombre_eleves" /></span>
                                                <span className="txt">{school.number_students}</span>
                                            </div>
                                        </li>
                                    }
                                    {teachingLangsStr !== '' &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepMessages} alt="" />
                                            </div>
                                            <div className="content">
                                                <span className="title"><Translate id="school_details.langues_instructions" /></span>
                                                <span className="txt">{teachingLangsStr}</span>
                                            </div>
                                        </li>
                                    }
                                    {typesOfSchool !== '' &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepBook} alt="" />
                                            </div>
                                            <div className="content">
                                                <span className="title"><Translate id="school_details.type_ecole" /></span>
                                                <span className="txt">{typesOfSchool}</span>
                                            </div>
                                        </li>
                                    }
                                    {certificationsStr !== '' &&
                                        <li>
                                            <div className="icon">
                                                <img src={IconAgepCertificate} alt="" />
                                            </div>
                                            <div className="content">
                                                <span className="title"><Translate id="school_details.certifications" /></span>
                                                <span className="txt">{certificationsStr}</span>
                                            </div>
                                        </li>
                                    }
                                </ul>
                                {(school.website && school.website !== '') &&
                                    <Button variant="contained" color="primary" size="large" id="btn-view-website" href={school.website} target="_blank" className="d-print-none">
                                        <Translate id="school_details.visiter_site" />
                                    </Button>
                                }
                            </div>
                            <div className="col col-right col-7 offset-1 d-none d-lg-flex">
                                <Fade>
                                    <div className="featured-image" style={thumbnailStyles}></div>
                                </Fade>
                            </div>
                        </div>
                    </header>
                    <div className="row row-content clearfix">
                        <div className="col col-left col-4 d-none d-lg-flex d-print-flex">
                            <address>
                                <div className="inner">
                                    <div className="map">
                                        <SchoolMap
                                            logo={school.logo}
                                            latitude={school.address_latitude}
                                            longitude={school.address_longitude}
                                            isMarkerShown
                                        />
                                    </div>
                                    <ul className="clearfix">
                                        {address !== '' &&
                                            <li>
                                                <span className="title"><Translate id="school_details.adresse" /></span>
                                                <div className="content">
                                                    {ReactHtmlParser(address)}<br />
                                                    <a href={'https://maps.google.com/?q=' + school.address_latitude + ',' + school.address_longitude} id="btn-view-place-map" target="_blank" className="d-print-none">
                                                        <Translate id="school_details.voir_google_maps" />
                                                    </a>
                                                </div>
                                            </li>
                                        }
                                        {(school.direction && school.direction !== '') &&
                                            <li>
                                                <span className="title"><Translate id="school_details.direction" /></span>
                                                <div className="content">{school.direction}</div>
                                            </li>
                                        }
                                        {(school.phone && school.phone !== '') &&
                                            <li>
                                                <span className="title"><Translate id="school_details.label_telephone" /></span>
                                                <div className="content">
                                                    {formatNumber(school.phone, 'International')}
                                                </div>
                                            </li>
                                        }
                                        {(school.fax && school.fax !== '') &&
                                            <li>
                                                <span className="title"><Translate id="school_details.label_fax" /></span>
                                                <div className="content">
                                                    {formatNumber(school.fax, 'International')}
                                                </div>
                                            </li>
                                        }
                                        {(school.contact && school.contact !== '') &&
                                            <li>
                                                <span className="title"><Translate id="school_details.email_contact" /></span>
                                                <div className="content">
                                                    <Obfuscate
                                                        email={school.contact}
                                                    />
                                                </div>
                                            </li>
                                        }
                                        {(school.website && school.website !== '') &&
                                            <li>
                                                <span className="title"><Translate id="school_details.site_internet" /></span>
                                                <div className="content">
                                                    <a href={school.website} target="_blank">{(school.website).replace('https://', '').replace('http://', '')}</a>
                                                </div>
                                            </li>
                                        }
                                        {(school.facebook && school.facebook !== '') &&
                                            <li>
                                                <span className="title"><Translate id="school_details.facebook" /></span>
                                                <div className="content">
                                                    <div className="d-print-none">
                                                        <a href={school.facebook} target="_blank"><Translate id="school_details.facebook_consulter" /></a>
                                                    </div>
                                                    <div className="d-print-block">
                                                        <a href={school.facebook} target="_blank">{school.facebook}</a>
                                                    </div>
                                                </div>
                                            </li>
                                        }
                                    </ul>
                                </div>
                            </address>
                        </div>
                        <div className="col col-right col-12 col-lg-6 offset-lg-1">
                            <section id="presentation">
                                <h2><Translate id="school_details.presentation" /></h2>
                                <div className="content">
                                    {ReactHtmlParser(school.content)}
                                </div>
                            </section>
                            {/*
                            {(Array.isArray(school.programmes) && school.programmes.length > 0) &&
                                <section id="school-programmes">
                                    <h2><Translate id="school_details.programmes" /></h2>
                                    <div className="content">
                                        <ul className="items clearfix">
                                            {school.programmes.map((programme, index) => (
                                                <li key={programme.term_id}>
                                                    <span className="icon">
                                                        <ChevronRightIcon className="m-icon"/>
                                                    </span>
                                                    {programme.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </section>
                            }
                            */}
                            {(Array.isArray(school.degrees) && school.degrees.length > 0) &&
                                <section id="school-degrees">
                                    <h2><Translate id="school_details.diplomes" /></h2>
                                    <div className="content">
                                        <ul className="items clearfix">
                                            {school.degrees.map((degree, index) => (
                                                <li key={degree.term_id}>
                                                    {/*<span className="icon">
                                                        <ChevronRightIcon className="m-icon"/>
                                                    </span>*/}
                                                    {degree.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </section>
                            }
                            {(schoolFees !== '' || (school.school_fees_description && school.school_fees_description !== '')) &&
                                <section id="school-fees">
                                    <h2><Translate id="school_details.ecolage" /></h2>
                                    <div className="content">
                                        <ul className="items clearfix">
                                            {schoolFees !== '' &&
                                                <li>
                                                    {/*<span className="icon">
                                                        <ChevronRightIcon className="m-icon"/>
                                                    </span>*/}
                                                    {schoolFees}
                                                </li>
                                            }
                                            {(school.school_fees_description && school.school_fees_description !== '') &&
                                                <li className="description">
                                                    {ReactHtmlParser(school.school_fees_description)}
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </section>
                            }
                        </div>
                    </div>
                </article>

                <AppBar position="fixed" className="bottom-tabs">
                    <Tabs fullWidth>
                        <Tab className="dark" label={this.props.translate('school_details.tab_coordonnees')} icon={<IconInfo2 className="btn-icon" />} onClick={this.toggleInfoDrawer(true)} />
                    </Tabs>
                </AppBar>

                <Drawer id="info-drawer" anchor="right" open={this.state.mobileInfoDrawerOpen} onClose={this.toggleInfoDrawer(false)} className="header-drawer" classes={{
                    paper: 'header-drawer-paper almost-full info-drawer',
                }}>
                    <div className="wrapper wrapper-top">
                        <div className="inner">
                            <div className="drawer-title">
                                <span className="section"><Translate id="school_details.drawer_info_section" /></span>
                                <h2 className="title"><Translate id="school_details.drawer_info_title" /></h2>
                                <Button size="large" className="btn-close-drawer" onClick={this.toggleInfoDrawer(false)}>
                                    <CloseIcon className="m-icon" />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper wrapper-bottom">
                        <div className="inner">
                            <div className="content">
                                <div className="map">
                                    <SchoolMap
                                        logo={school.logo}
                                        latitude={school.address_latitude}
                                        longitude={school.address_longitude}
                                        isMarkerShown
                                    />
                                </div>
                                <ul className="clearfix">
                                    {address !== '' &&
                                        <li>
                                            <span className="title"><Translate id="school_details.adresse" /></span>
                                            <div className="content">
                                                {ReactHtmlParser(address)}<br />
                                                <a href={'https://maps.google.com/?q=' + school.address_latitude + ',' + school.address_longitude} id="btn-view-place-map" target="_blank" className="d-print-none">
                                                    <Translate id="school_details.voir_google_maps" />
                                                </a>
                                            </div>
                                        </li>
                                    }
                                    {(school.direction && school.direction !== '') &&
                                        <li>
                                            <span className="title"><Translate id="school_details.direction" /></span>
                                            <div className="content">{school.direction}</div>
                                        </li>
                                    }
                                    {(school.phone && school.phone !== '') &&
                                        <li>
                                            <span className="title"><Translate id="school_details.label_telephone" /></span>
                                            <div className="content">
                                                {formatNumber(school.phone, 'International')}
                                            </div>
                                        </li>
                                    }
                                    {(school.fax && school.fax !== '') &&
                                        <li>
                                            <span className="title"><Translate id="school_details.label_fax" /></span>
                                            <div className="content">
                                                {formatNumber(school.fax, 'International')}
                                            </div>
                                        </li>
                                    }
                                    {(school.contact && school.contact !== '') &&
                                        <li>
                                            <span className="title"><Translate id="school_details.email_contact" /></span>
                                            <div className="content">
                                                <Obfuscate
                                                    email={school.contact}
                                                />
                                            </div>
                                        </li>
                                    }
                                    {(school.website && school.website !== '') &&
                                        <li>
                                            <span className="title"><Translate id="school_details.site_internet" /></span>
                                            <div className="content">
                                                <a href={school.website} target="_blank">{(school.website).replace('https://', '').replace('http://', '')}</a>
                                            </div>
                                        </li>
                                    }
                                    {(school.facebook && school.facebook !== '') &&
                                        <li>
                                            <span className="title"><Translate id="school_details.facebook" /></span>
                                            <div className="content">
                                                <a href={school.facebook} target="_blank"><Translate id="school_details.facebook_consulter" /></a>
                                            </div>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </Drawer>
            </Fragment>
        );
    }
}

SchoolDetails.propTypes = {
    school: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(SchoolDetails);


// WEBPACK FOOTER //
// ./src/features/Schools/components/Details/SchoolDetails.js